module.exports = __webpack_public_path__ + "img/40_31.06c7ced8.png";